import { useMemo } from 'react';
import { useAsPath } from 'src/hooks/useAsPath';
import {
  PersonalManager,
  PersonalManagerProps,
} from 'src/uikit/PersonalManager';
import { scrollToElementWithId } from 'src/utils/scrollToElementWithId';

type ConsultationProps = {
  onClick: () => void;
  data: PersonalManagerProps;
};

export function Consultation({ onClick, data }: ConsultationProps) {
  const asPath = useAsPath();

  const slug = useMemo(
    () => asPath?.split('/').at(-1)?.split('?')[0] ?? '',
    [asPath],
  );

  const handleClick = () => {
    scrollToElementWithId('form');
    onClick();
  };

  return (
    <PersonalManager
      button={{
        title: 'Получить консультацию',
        onClick: handleClick,
        analyticsOptions: {
          action: 'click',
          clickZone: 'body',
          clickElement: 'button',
          clickContent: 'Получить консультацию',
          uniqueId: `${slug}-personal-manager-button-scroll-to-form`,
          transitionType: 'inside-link',
        },
      }}
      {...data}
    />
  );
}
